import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormCheck from '../../components/FormCheck'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiCheckbox-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  borderWidth: 1,
  borderColor: 'primary.main',
  borderStyle: 'solid',
  display: 'inline-flex',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const EmployeeBenefits = ({ validate }: FormSectionProps) => {
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            Do you get any of these benefits from your employer?
          </Typography>
          <Typography variant="body1" sx={{ mb: 8 }}>
            Select all that apply.
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="critical-illness" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="critical-illness"
                  name="employeeBenefits"
                  value="Critial Illness"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Critial Illness
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="death-in-service" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="death-in-service"
                  name="employeeBenefits"
                  value="Death in Service"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Death in Service
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="income-protection"
                style={{ textAlign: 'center' }}
              >
                <FormCheck
                  id="income-protection"
                  name="employeeBenefits"
                  value="Income Protection"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Income Protection
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="none" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="none"
                  name="employeeBenefits"
                  value="None"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  None
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="not-sure" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="not-sure"
                  name="employeeBenefits"
                  value="Not sure"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Not sure
                </Typography>
              </label>
            </Grid>
          </Grid>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default EmployeeBenefits
